import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { VStack } from '@pets-ui/VStack/VStack'

export const PromotionCouponListSkeleton = () => {
  return (
    <VStack gap={2}>
      <Skeleton width="100%" height={124} />
      <Skeleton width="100%" height={124} />
      <Skeleton width="100%" height={124} />
      <Skeleton width="100%" height={124} />
      <Skeleton width="100%" height={124} />
      <Skeleton width="100%" height={124} />
      <Skeleton width="100%" height={124} />
      <Skeleton width="100%" height={124} />
    </VStack>
  )
}
